<template>
	<div style="padding: 0px;">
		<el-form :inline="false" :model="sysroleinfo" :rules="rules" ref="sysrolerule" label-width="120px" class="">
			<el-row>
				<el-col :span="6">
					<el-form-item label="角色名" prop="name">
						<el-input clearable :disabled="!editok" v-model="sysroleinfo.name" maxlength="30"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="校区" prop="orgid">
						<el-select style="width: 100%;" filterable clearable :disabled="!editok" v-model="sysroleinfo.orgid" 
							placeholder="请选择校区" >
							<el-option v-for="item in orgList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<div style="text-align: center;">
			<el-button v-show="!editok" type="primary" @click="editok = true">修改</el-button>
			<el-button v-show="editok" plain @click="closeDlg">取消</el-button>
			<el-button v-show="editok" type="primary" @click="saveSysRole">保存</el-button>
		</div>
		
	</div>
</template>

<script> 
	import { addSysRole, editSysRole } from '/static/apiUrl.js'
	export default {
		name : 'RoleDetail',
		data() {
			return {
				editok: false,
				disabled_cord: false,
				sysroleinfo : {
					id: "",
					name: "",
					orgid: "",
				},
				rules:{
					name: [
						{ required: true, message: '请输入名称', trigger: 'blur' }
					],
					orgid: [
						{ required: true, message: '请选择所属组织', trigger: 'blur' }
					],
				},
			}
		},
		mounted() {
			
		},
		BeforeCreate(){
			
		},
		props: {
			selectedrole: {
				type: Object,
				required: false
			},
			add : {
				type : Boolean,
				required : false,
				default : false,
			},
			orgList : {
				type : Array,
				required: true
			},
		},
		watch: {
			add : {
				immediate: true,
				handler(newVal) {
					if(newVal == true){
						this.editok = true
					}else{
						this.editok = false
					}
				}
			},
			selectedrole: {
				immediate: true,
				handler(newVal) {
					if(newVal != null){
						this.sysroleinfo.id = newVal.id
						this.sysroleinfo.name= newVal.name
						this.sysroleinfo.orgid = newVal.orgid
					}else{
						this.sysroleinfo.id = ""
						this.sysroleinfo.name=""
						this.sysroleinfo.orgid = ""
					}
				}
			},
		},
		methods: {
			closeDlg() {
				this.editok = false
				if(this.add){
					this.$emit("needRefrash",false,false)
				}
			},
			saveSysRole(){
				this.$refs["sysrolerule"].validate((valid) => {
					if (valid) {
						if(this.sysroleinfo.id != null && this.sysroleinfo.id != ''){  //编辑
							editSysRole(this.sysroleinfo).then(res => {
								if(0 == res.code){
									this.$message({
										showClose: true,
										message: "修改成功",
										type: 'success'
									});
									this.$emit("needRefrash",true,false)
								}else{
									this.$message({
										showClose: true,
										message: res.message,
										type: 'error'
									});
								}
							})
						}else{ //新增
							addSysRole(this.sysroleinfo).then(res => {
								if(0 == res.code){
									this.$message({
										showClose: true,
										message: "添加成功",
										type: 'success'
									});
									this.$emit("needRefrash",true,false)
								}else{
									this.$message({
										showClose: true,
										message: res.message,
										type: 'error'
									});
								}
							})
						}
					} else {
						return false;
					}
				});
			},
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>